
import React from "react";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from "@/hooks/useAuth";
import { GDPRProvider } from "@/components/gdpr/GDPRProvider";
import AppContent from "./components/AppContent";

// Create a stable QueryClient instance
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1 * 60 * 1000, // 1 minute - reduced from 5 minutes
      gcTime: 5 * 60 * 1000, // 5 minutes - reduced from 10 minutes
      retry: 1, // reduced from 3
      refetchOnWindowFocus: false,
      refetchOnMount: false, // changed from true to prevent excessive refetching
      refetchOnReconnect: true,
    },
  },
});

function App() {
  console.log('App component rendering...');
  
  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <BrowserRouter>
            <AuthProvider>
              <GDPRProvider>
                <Toaster />
                <AppContent />
              </GDPRProvider>
            </AuthProvider>
          </BrowserRouter>
        </TooltipProvider>
      </QueryClientProvider>
    </HelmetProvider>
  );
}

export default App;
